export default __webpack_public_path__ + "static/media/AskMeLogoOptimized.c53e5957.webp";